import React from 'react';
import { useValidationContext } from '../../context/validation.js';
import useFromAmount from '../../hooks/use-from-amount.js';
import { useLimitsContext } from '../../context/limits.js';
import usePrefilledAmountId from '../../hooks/use-prefilled-amount-id.js';
import useSwapMode from '../../hooks/use-swap-mode.js';
import useToAmount from '../../hooks/use-to-amount.js';
import useIsExchanging from '../../hooks/use-is-exchanging.js';
const ErrorComponent = ({ Component, className, style }) => {
    const { currentError } = useValidationContext();
    const [fromAmount] = useFromAmount();
    const [toAmount] = useToAmount();
    const limits = useLimitsContext();
    const [prefillAmountId] = usePrefilledAmountId();
    const [swapMode] = useSwapMode();
    const isExchanging = useIsExchanging();
    const didUserInteract = (swapMode === 'ExactIn' ? fromAmount.isPositive : toAmount.isPositive) || !!prefillAmountId;
    if (limits.loading || !didUserInteract || !currentError || !Component || isExchanging) {
        return null;
    }
    return (React.createElement(Component, { type: currentError.type, reason: currentError.reason, payload: currentError.payload, className: className, style: style }));
};
export default ErrorComponent;
